import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

interface NavGroup {
  label: string;
  items: { label: string; path: string }[];
}

const navGroups: NavGroup[] = [
  {
    label: 'Clients',
    items: [
      { label: 'Accounts', path: '/account' },
      { label: 'Contacts', path: '/contact' },
      { label: 'Leads', path: '/lead' },
    ],
  },
  {
    label: 'Advisory',
    items: [
      { label: 'Reviews', path: '/t4a_review' },
      { label: 'Planning Objectives', path: '/t4a_planningobjective' },
      { label: 'Recommendations', path: '/t4a_curorecommendation' },
      { label: 'ATR', path: '/t4a_atr' },
    ],
  },
  {
    label: 'Products',
    items: [
      { label: 'Holdings', path: '/t4a_curoholding' },
      { label: 'Products', path: '/t4a_curoproduct' },
      { label: 'Tranches', path: '/t4a_tranche' },
      { label: 'Providers', path: '/t4a_provider' },
      { label: 'Model Portfolios', path: '/t4a_modelportfolio' },
    ],
  },
  {
    label: 'Activities',
    items: [
      { label: 'Tasks', path: '/task' },
      { label: 'Phone Calls', path: '/phonecall' },
      { label: 'Projects', path: '/t4a_milestone' },
      { label: 'Project Categories', path: '/t4a_milestonecategory' },
      { label: 'Project Stages', path: '/t4a_milestoneevent' },
    ],
  },
  {
    label: 'Fees',
    items: [
      { label: 'Fee Components', path: '/t4a_feecomponent' },
      { label: 'Fee Profiles', path: '/t4a_feeprofile' },
      { label: 'Income Profiles', path: '/t4a_incomeprofile' },
    ],
  },
  {
    label: 'People',
    items: [
      { label: 'System Users', path: '/systemuser' },
      { label: 'Business Units', path: '/businessunit' },
      { label: 'Sites', path: '/site' },
      { label: 'Provider Contacts', path: '/t4a_providercontact' },
    ],
  },
  {
    label: 'Other',
    items: [
      { label: 'Currencies', path: '/transactioncurrency' },
      { label: 'Annotations', path: '/annotation' },
      { label: 'Activity Groups', path: '/t4a_activitygroup' },
      { label: 'Interested Parties', path: '/t4a_beneficiary' },
      { label: 'Assets', path: '/t4a_asset' },
      { label: 'Liabilities', path: '/t4a_liabilities' },
      { label: 'Gifts', path: '/t4a_gift' },
      { label: 'Income', path: '/t4a_income' },
      { label: 'Expenditure', path: '/t4a_expenditure' },
      { label: 'Advice Categories', path: '/t4a_advicecategory' },
    ],
  },
  {
    label: 'Admin',
    items: [
      { label: 'Data Reset', path: '/admin/reset' },
    ],
  },
];

export function Sidebar() {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  function toggle(label: string) {
    setCollapsed(prev => ({ ...prev, [label]: !prev[label] }));
  }

  return (
    <aside className="w-60 bg-slate-900 text-slate-200 overflow-y-auto flex-shrink-0">
      <div className="p-4 border-b border-slate-700">
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-bold text-white">MockCuro</h1>
          {import.meta.env.VITE_DEPLOY_ENV && (
            <span className="px-1.5 py-0.5 text-[10px] font-semibold uppercase rounded bg-amber-500/20 text-amber-400 tracking-wide">
              {import.meta.env.VITE_DEPLOY_ENV}
            </span>
          )}
        </div>
        <p className="text-xs text-slate-400">CRM Mock System</p>
      </div>
      <nav className="py-2">
        {navGroups.map(group => (
          <div key={group.label}>
            <button
              onClick={() => toggle(group.label)}
              className="w-full flex items-center justify-between px-4 py-2 text-xs font-semibold uppercase tracking-wider text-slate-400 hover:text-slate-200"
            >
              {group.label}
              <span className="text-[10px]">{collapsed[group.label] ? '+' : '-'}</span>
            </button>
            {!collapsed[group.label] && (
              <ul>
                {group.items.map(item => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        `block px-6 py-1.5 text-sm transition-colors ${
                          isActive
                            ? 'bg-slate-700 text-white font-medium'
                            : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </nav>
    </aside>
  );
}
